export const PathologyResultAlertPath =
  'detail.fhir.interpretation[0].coding[0]';

export const PathologyValuePath = 'detail.fhir.valueQuantity.value';

export enum PathologyAlertResult {
  AbnormalAlert = 'AA',
  High = 'H',
  Low = 'L',
  UndetectableOruUnknown = 'U',
}

export enum TimelineItemType {
  DotBlue = 'dotBlue',
  DotRed = 'dotRed',
  DotPurple = 'dotPurple',
  DotDarkBlue = 'dotDarkBlue',
  DotGray = 'dotGray',
}
